import React from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import DashboardLoading from '@core/dashboard/components/DashboardLoading';
import { ConferenceProvider } from '@core/dashboard/components/DashboardContent/Dolby';
import { CommunicationsProvider } from '@core/communications/providers/CommunicationsProvider';
import IdleTimerWithModal from '@components/IdleTimerModal';

const EventPageWrapper: React.FC = () => {
  const context = useOutletContext();

  return (
    <ConferenceProvider>
      <CommunicationsProvider>
        <IdleTimerWithModal />
        <DashboardLoading />
        <Outlet context={context} />
      </CommunicationsProvider>
    </ConferenceProvider>
  );
};

export default EventPageWrapper;
